<template>
  <div class="container">
    <div class="row">
      <div class="col-md-4">
        <el-dropdown>
          <el-select
            v-model="selectedValue"
            placeholder="Selecione a VSL"
          >
            <el-option
              v-for="item in options"
              :id="item.id"
              :key="item.vsl_name"
              :label="item.vsl_name"
              :value="item.id"
              @click="getAnaliseVsl(); getDataFilter(value);"
            />
          </el-select>
        </el-dropdown>
      </div>
      <div
        v-if="$route.name === 'DashboardVsl'"
        class="col-6 text-right "
        style="margin-left: -159px;"
      >
        <div class="col-md-4">
          <el-dropdown @click.stop>
            <el-select
              v-model="value"
              placeholder="Selecione"
              size="large"
            >
              <el-option
                v-for="item in optionsData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
              <div
                class="row"
                style="margin: 0 1px 0px 0px;"
              >
                <div class="col">
                  <el-input
                    id="data_inicial"
                    v-model="endDate"
                    class="ajuste-input-date"
                    maxlength="10"
                    show-word-limit
                    type="date"
                  />
                </div>
                <div
                  class="col align-self-lg-center"
                  style="padding: 0"
                >
                  <span>até</span>
                </div>
                <div class="col">
                  <el-input
                    id="data_final"
                    v-model="startDate"
                    class="ajuste-input-date"
                    maxlength="10"
                    show-word-limit
                    type="date"
                  />
                </div>
                <div
                  class="col"
                  style="padding-left: 0"
                >
                  <el-button
                    :disabled="startDate <= endDate && startDate !== ''"
                    type="primary"
                    @click="getFilterDataIntervalo"
                  >
                    Filtrar
                  </el-button>
                </div>
              </div>

            </el-select>
          </el-dropdown>

        </div>

      </div>
      <div
        class="col-md-2"
        style="margin-right:-706px;margin-left: 121px;"
      >
        <h4
          style="background-color: #ffffff;
    border-radius: 10px;
    border: 1px solid #c9c9c9;
    padding: 6px;text-align: center;
    "
        > {{ dadosPagamento.planocontratado }}</h4>
      </div>
    </div>
    <div class="row match-height mt-4">
      <div class="col-sm-3 col-md-3 col-12">
        <b-card
          id="views"
          class="earnings-card hover"
        >
          <b-row class="align-self-center">
            <b-col cols="7">
              <b-card-title class="mb-1">
                Visualizações
              </b-card-title>
              <div class="font-small-8">
                Este mês
              </div>
              <h5 class="mb-1">
                {{ Views.views }}
              </h5>
              <b-card-text class="text-muted font-small-2" />
            </b-col>
            <b-col
              cols="5"
              class="aling-icon"
            >
              <div
                id="card1"
                class="aling-center-icon-item"
              >
                <i class="el-icon-view" />
              </div>
            </b-col>
          </b-row>

        </b-card>
      </div>
      <div class="col-sm-3 v-col-md-3 v-col-12">
        <b-card
          id="paly"
          class="earnings-card"
        >
          <b-row>
            <b-col cols="7">
              <b-card-title class="mb-1">
                Plays
              </b-card-title>
              <div class="font-small-8">
                Este mês
              </div>
              <h5 class="mb-1">
                {{ Play.play }}/{{ dadosPagamento.numero_plays_disponivel }}
              </h5>
              <!--              <b-card-text class="text-muted font-small-2">-->
              <!--                <span-->
              <!--                  id="textPlay"-->
              <!--                  class="font-weight-bolder"-->
              <!--                >68.2%</span><span id="text2"> mais cliques do que no mês-->
              <!--                  passado.</span>-->
              <!--              </b-card-text>-->
            </b-col>
            <b-col
              cols="5"
              class="aling-icon "
            >
              <div
                id="card2"
                class="aling-center-icon-item"
              >
                <i class="el-icon-video-play" />
              </div>
            </b-col>
          </b-row>
        </b-card>
      </div>
      <div class="col-sm-3 v-col-md-3 v-col-12">
        <b-card
          id="PlayRate"
          class="earnings-card"
        >
          <b-row>
            <b-col cols="7">
              <b-card-title class="mb-1">
                Play Rate
              </b-card-title>
              <div class="font-small-8">
                Este mês
              </div>
              <h5 class="mb-1">
                {{ PlayRate.playRate }}%
              </h5>
              <!-- <b-card-text class="text-muted font-small-2">
                <span id="textPlayRate" class="font-weight-bolder">68.2%</span><span id="text2"> mais ganhos do que no
                  mês passado.</span>
              </b-card-text> -->
            </b-col>
            <b-col
              cols="5"
              class="aling-icon "
            >
              <div
                id="card3"
                class="aling-center-icon-item"
              >
                <i class="el-icon-s-data" />
              </div>
            </b-col>
          </b-row>
        </b-card>
      </div>
      <div class="col-sm-3 v-col-md-3 v-col-12">
        <b-card
          id="Engajamento"
          class="earnings-card"
        >
          <b-row>
            <b-col cols="7">
              <b-card-title class="mb-1">
                Engajamento
              </b-card-title>
              <div class="font-small-8">
                Este mês
              </div>
              <h5 class="mb-1">
                {{ Engajamento.engajamento }}%
              </h5>
              <!-- <b-card-text class="text-muted font-small-2">
                <span id="textEngajamento" class="font-weight-bolder">68.2%</span><span id="text2"> mais engajado do que
                  no mês passado.</span>
              </b-card-text> -->
            </b-col>
            <b-col
              cols="5"
              class="aling-icon "
            >
              <div
                id="card4"
                class="aling-center-icon-item"
              >
                <i class="el-icon-s-marketing" />
              </div>
            </b-col>

          </b-row>
        </b-card>
      </div>
      <div class="col-sm-12 v-col-md-3 v-col-12">
        <FunnelGraph :objs-funnel-geral="objsFunnelGeral" />
      </div>
      <div class="col-sm-6 md-3 v-col-12">
        <b-card
            id="viewsEngagement"
          no-body
          class="graphic"
        >
          <b-card-header>
            <b-card-title style="color: #f5f5f5">
              Visualizações X Engajamento
            </b-card-title>
            <!--            <feather-icon icon="SettingsIcon" size="18" class="text-muted cursor-pointer" />-->
          </b-card-header>
          <b-card-body class="pb-0">
            <div class="d-flex justify-content-start mb-3">
              <div class="mr-2" />
              <div />
            </div>

            <!-- apex chart -->
            <vue-apex-charts
              ref="viewsEngagementLine"
              type="line"
              height="240"
              :options="revenueComparisonLine.chartOptions"
              :series="revenueComparisonLine.series"
            />
          </b-card-body>
        </b-card>
      </div>
      <div class="col-sm-6 md-3 v-col-12">
        <b-card
            id="playsEngagement"
          no-body
          class="graphic"
        >
          <b-card-header>
            <b-card-title style="color: #f5f5f5">
              Play X Engajamento
            </b-card-title>
            <!--            <feather-icon icon="SettingsIcon" size="18" class="text-muted cursor-pointer" />-->
          </b-card-header>
          <b-card-body class="pb-0 ">
            <div class="d-flex justify-content-start mb-3">
              <div class="mr-2">
                <!--                <b-card-text class="mb-50">-->
                <!--                  Plays-->
                <!--                </b-card-text>-->
                <h3 class="font-weight-bolder">
                  <!--                  <sup class="font-medium-1">$ </sup>-->
                  <!--                  <span class="text-primary">{{ revenue.thisMonth }}</span>-->
                </h3>
              </div>
              <div>
                <!--                <b-card-text class="mb-50">-->
                <!--                  Engajamento-->
                <!--                </b-card-text>-->
                <h3 class="font-weight-bolder">
                  <!--                  <sup class="font-medium-1">$ </sup>-->
                  <!--                  <span>{{ revenue.lastMonth }}</span>-->
                </h3>
              </div>
            </div>
            <!-- {{ Views.chartOptions.plotOptions.pie.donut.labels.total}} -->

            <vue-apex-charts
              ref="playEngaja"
              type="line"
              height="240"
              :options="PlayXengajamento.chartOptions"
              :series="PlayXengajamento.series"
            />
          </b-card-body>
        </b-card>

      </div>
    </div>

  </div>
</template>

<script>
import {
  BCardHeader, BCardBody, BCard, BRow, BCol, BCardTitle, BCardText,
} from 'bootstrap-vue'

import { useApi } from '@/composables/useApi'

import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'
import { formatDate } from '@core/utils/dateFormat'
import { AnalyticService } from '@/services/Analytic'
import FunnelGraph from '@/views/App/Dashboard/FunnelGraph.vue'

const api = useApi()

const analyticService = new AnalyticService()
const $earningsStrokeViewsColor2 = '#5BC9EB'
const $earningsStrokeViewsColor3 = '#5BEB84'
const $earningsStrokeViewsColor4 = '#4bab95'

const $earningsStrokePlayColor2 = '#FDDC6D'
const $earningsStrokePlayColor3 = '#FDA06D'
const $earningsStrokePlayColor4 = '#ca9650'

const $earningsStrokePlayRateColor2 = '#3359DE'
const $earningsStrokePlayRateColor3 = '#40ABDE'
const $earningsStrokePlayRateColor4 = '#447fc8'

const $earningsStrokeEngajamentoColor2 = '#E046A2'
const $earningsStrokeEngajamentoColor3 = '#E04538'
const $earningsStrokeEngajamentoColor4 = '#c9495f'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BCardTitle,
    BCardText,
    VueApexCharts,

    BCardHeader,
    BCardBody,
    FunnelGraph,
  },

  data() {
    return {
      objsFunnelGeral: {},
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND,
      dadosPagamento: [],
      responseGeral: [],
      dataIsValid: false,
      startDate: null,
      endDate: null,
      data: [],
      dashbord: true,
      visualizacao: 0,
      engajamentoG: 0,
      playy: 0,
      Views: {

        views: '0',
        series: [53, 16, 31],
        chartOptions: {
          chart: {
            type: 'donut',
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: { show: false },
          comparedResult: [2, -3, 8],
          labels: ['esse', 'Mês passado', 'Este mês'],
          stroke: { width: 0 },
          colors: [$earningsStrokeViewsColor2, $earningsStrokeViewsColor3, $earningsStrokeViewsColor4],
          grid: {
            padding: {
              right: -20,
              bottom: -8,
              left: -20,
            },
          },
          plotOptions: {
            pie: {
              startAngle: -10,
              donut: {
                labels: {
                  show: true,
                  name: {
                    offsetY: 15,
                  },
                  value: {
                    offsetY: -15,
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}%`
                    },
                  },
                  total: {

                    show: true,
                    offsetY: 15,
                    label: 'Views',
                    formatter(val) {
                      console.log('teste', val.config.plotOptions.pie.donut.labels.total)
                    },
                  },
                },
              },
            },
          },
          responsive: [
            {
              breakpoint: 1325,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 1200,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
            {
              breakpoint: 1045,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
          ],
        },
      },

      Play: {
        play: '',
        series: [53, 16, 31],
        chartOptions: {
          chart: {
            type: 'donut',
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: { show: false },
          comparedResult: [2, -3, 8],
          labels: ['', 'Mês passado', 'Este mês'],
          stroke: { width: 0 },
          colors: [$earningsStrokePlayColor2, $earningsStrokePlayColor3, $earningsStrokePlayColor4],
          grid: {
            padding: {
              right: -20,
              bottom: -8,
              left: -20,
            },
          },
          plotOptions: {
            pie: {
              startAngle: -10,
              donut: {
                labels: {
                  show: true,
                  name: {
                    offsetY: 15,
                  },
                  value: {
                    offsetY: -15,
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}%`
                    },
                  },
                  total: {
                    show: true,
                    offsetY: 15,
                    label: 'Plays',
                    formatter() {
                      return '10'
                    },
                  },
                },
              },
            },
          },
          responsive: [
            {
              breakpoint: 1325,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 1200,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
            {
              breakpoint: 1045,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
          ],
        },
      },

      PlayRate: {
        playRate: '',
        series: [53, 16, 31],
        chartOptions: {
          chart: {
            type: 'donut',
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: { show: false },
          comparedResult: [2, -3, 8],
          labels: ['', 'Mês passado', 'Este mês'],
          stroke: { width: 0 },
          colors: [$earningsStrokePlayRateColor2, $earningsStrokePlayRateColor3, $earningsStrokePlayRateColor4],
          grid: {
            padding: {
              right: -20,
              bottom: -8,
              left: -20,
            },
          },
          plotOptions: {
            pie: {
              startAngle: -10,
              donut: {
                labels: {
                  show: true,
                  name: {
                    offsetY: 15,
                  },
                  value: {
                    offsetY: -15,
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}%`
                    },
                  },
                  total: {
                    show: true,
                    offsetY: 15,
                    label: 'PlayRate',
                    formatter() {
                      return '85'
                    },
                  },
                },
              },
            },
          },
          responsive: [
            {
              breakpoint: 1325,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 1200,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
            {
              breakpoint: 1045,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
          ],
        },
      },

      Engajamento: {
        engajamento: '',
        series: [53, 16, 31],
        chartOptions: {
          chart: {
            type: 'donut',
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: { show: false },
          comparedResult: [2, -3, 8],
          labels: ['', 'Mês passado', 'Este mês'],
          stroke: { width: 0 },
          colors: [$earningsStrokeEngajamentoColor2, $earningsStrokeEngajamentoColor3, $earningsStrokeEngajamentoColor4],
          grid: {
            padding: {
              right: -20,
              bottom: -8,
              left: -20,
            },
          },
          plotOptions: {
            pie: {
              startAngle: -10,
              donut: {
                labels: {
                  show: true,
                  name: {
                    offsetY: 15,
                  },
                  value: {
                    offsetY: -15,
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}%`
                    },
                  },
                  total: {
                    show: true,
                    offsetY: 15,
                    label: ' Engajamento',
                    formatter() {
                      return '85'
                    },
                  },
                },
              },
            },
          },
          responsive: [
            {
              breakpoint: 1325,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 1200,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
            {
              breakpoint: 1045,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
          ],
        },
      },

      options: [],

      selectedValue: '',

      revenue: {},

      revenueComparisonLine: {
        series: [
          {
            name: 'Visualizações',
            data: [],
          },
          {
            name: 'Engajamento',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: { show: false },
            zoom: { enabled: false },
            type: 'line',
            offsetX: -10,
          },
          stroke: {
            curve: 'smooth',
            dashArray: [0, 12],
            width: [4, 3],
          },
          legend: {
            show: false,
          },
          colors: ['#65ddc1', '#f17c92'],
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'dark',
              inverseColors: false,
              gradientToColors: [$themeColors.primary, '#ebe9f1'],
              shadeIntensity: 1,
              type: 'horizontal',
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100],
            },
          },
          markers: {
            size: 0,
            hover: {
              size: 5,
            },
          },
          xaxis: {
            labels: {
              style: {
                colors: '#b9b9c3',
                fontSize: '1rem',
              },
            },
            axisTicks: {
              show: false,
            },
            categories: [],
            axisBorder: {
              show: false,
            },
            tickPlacement: 'on',
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                colors: '#b9b9c3',
                fontSize: '1rem',
              },
              formatter(val) {
                return val > 999 ? `${(val / 1000).toFixed(0)}k` : val
              },
            },
          },
          grid: {
            borderColor: '#e7eef7',
            padding: {
              top: -20,
              bottom: -10,
              left: 20,
            },
          },
          tooltip: {
            x: { show: false },
          },
        },
      },
      PlayXengajamento: {
        series: [
          {
            name: 'Play',
            data: [],
          },
          {
            name: 'Engajamento',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: { show: false },
            zoom: { enabled: false },
            type: 'line',
            offsetX: -10,
          },
          stroke: {
            curve: 'smooth',
            dashArray: [0, 12],
            width: [4, 3],
          },
          legend: {
            show: false,
          },
          colors: ['#fbc77b', '#f17c92'],
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'dark',
              inverseColors: false,
              gradientToColors: [$themeColors.primary, '#ebe9f1'],
              shadeIntensity: 1,
              type: 'horizontal',
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100],
            },
          },
          markers: {
            size: 0,
            hover: {
              size: 5,
            },
          },
          xaxis: {
            labels: {
              style: {
                colors: '#b9b9c3',
                fontSize: '1rem',
              },
            },
            axisTicks: {
              show: false,
            },

            categories: [],
            axisBorder: {
              show: false,
            },
            tickPlacement: 'on',
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                colors: '#b9b9c3',
                fontSize: '1rem',
              },
              formatter(val) {
                return val > 999 ? `${(val / 1000).toFixed(0)}k` : val
              },
            },
          },
          grid: {
            borderColor: '#e7eef7',
            padding: {
              top: -20,
              bottom: -10,
              left: 20,
            },
          },
          tooltip: {
            x: { show: false },
          },
        },
      },
      optionsData: [
        {
          value: 'hoje',
          label: 'Hoje',
        },
        {
          value: 'ontem',
          label: 'Ontem',
        },
        {
          value: 'sete_dias',
          label: 'Últimos 7 dias',
        },
        {
          value: 'trinta_dias',
          label: 'Últimos 30 dias',
        },
        {
          value: 'full_dias',
          label: 'Tempo todo',
        },
      ],
      value: 'sete_dias',

    }
  },

  computed: {

    getUserData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
    formattedDate() {
      return this.$moment(this.apiDate).format('DD MMM')
    },
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.getDataFilter(newValue)
      }
    },
    selectedValue(newValue) {
      if (newValue) {
        this.getAnaliseVsl()
        this.getDataFilter(this.value)
      }
    },
  },
  mounted() {
    let obj = {
      vslbooster: 'DashboardVsl',
      chatbooster: 'DashboardChat',

    }
    if (this.$store.getters['User/GET_ROUTE_ROLE'] && this.$store.getters['User/GET_ROUTE_ROLE'] !== 'admin') {
      this.$router.push({ name: obj[this.$store.getters['User/GET_ROUTE_ROLE']] })
    }
    this.buscarDados()

    if (this.$route.name === 'DashboardVsl') {
      this.getDataFilter(this.value)
    }
    this.getAnalyticUserId()
    this.getvsls()
    this.getData()
    // setInterval(() => {
    //   this.getData()
    // }, 5000)
  },

  methods: {

    buscarDados() {
      const options = { method: 'GET' }

      fetch(`${this.VUE_APP_HOST_API_BACKEND}/pagamento/${this.getUserData.id}`, options)
        .then(response => response.json())
        .then(response => {
          this.dadosPagamento = response[0]
        })
        .catch(err => console.error(err))
    },

    getDataFilter(TypeDate) {
      const dataFilter = new Date()
      if (typeof TypeDate === 'undefined') {
        this.getFilterData7days(dataFilter)
      }
      if (TypeDate === 'hoje') {
        this.getFilterDateHoje(dataFilter)
      }
      if (TypeDate === 'ontem') {
        this.getFilterDataOtem(dataFilter)
      }
      if (TypeDate === 'sete_dias') {
        this.getFilterData7days(dataFilter)
      }
      if (TypeDate === 'trinta_dias') {
        this.getFilterData30days(dataFilter)
      }
      if (TypeDate === 'full_dias') {
        this.getFilterDataTempoTodo(dataFilter)
      }
    },
    async getFilterDateHoje(dataFilter) {
      if (this.selectedValue.length === 0) {
        await analyticService.getDashBoardGrl(this.getUserData.id, {
          start_date: `${formatDate(dataFilter)}`,
          end_date: `${formatDate(dataFilter)}`,
        })
          .then(res => {
            this.responseGeral = res
            this.getAnalyticUserId()
          })
      }
      if (this.selectedValue.length > 0) {
        await analyticService.getByIdVslObjts(this.selectedValue, {
          start_date: `${formatDate(dataFilter)}`,
          end_date: `${formatDate(dataFilter)}`,
        })
          .then(res => {
            this.responseObj = res
            this.getAnaliseVsl()
          })
      }
    },
    async getFilterDataOtem(dataFilter) {
      if (this.selectedValue.length === 0) {
        dataFilter.setDate(dataFilter.getDate() - 1)

        await analyticService.getDashBoardGrl(this.getUserData.id, {
          start_date: `${formatDate(dataFilter)}`,
          end_date: `${formatDate(dataFilter)}`,
        })
          .then(res => {
            this.responseGeral = res
            this.getAnalyticUserId()
          })
      }
      if (this.selectedValue.length > 0) {
        dataFilter.setDate(dataFilter.getDate() - 1)

        await analyticService.getByIdVslObjts(this.selectedValue, {
          start_date: `${formatDate(dataFilter)}`,
          end_date: `${formatDate(dataFilter)}`,
        })
          .then(res => {
            this.responseObj = res
            this.getAnaliseVsl()
          })
      }
    },
    async getFilterData7days(dataFilter) {
      const currentDate = new Date()
      if (this.selectedValue.length === 0) {
        dataFilter.setDate(dataFilter.getDate() - (7 - dataFilter.getDay() + 1))
        await analyticService.getDashBoardGrl(this.getUserData.id, {
          start_date: `${formatDate(currentDate)}`,
          end_date: `${formatDate(dataFilter)}`,
        })
          .then(res => {
            this.responseGeral = res
            this.getAnalyticUserId()
          })
      }
      if (this.selectedValue.length > 0) {
        dataFilter.setDate(dataFilter.getDate() - (7 - dataFilter.getDay() + 1))
        await analyticService.getByIdVslObjts(this.selectedValue, {
          start_date: `${formatDate(currentDate)}`,
          end_date: `${formatDate(dataFilter)}`,
        })
          .then(res => {
            this.responseObj = res
            this.getAnaliseVsl()
          })
      }
    },
    async getFilterData30days(dataFilter) {
      const currentData = new Date()
      if (this.selectedValue.length === 0) {
        dataFilter.setDate(dataFilter.getDate() - (30 - dataFilter.getDay() + 2))
        this.startDate = `${formatDate(currentData)}`
        this.endDate = `${formatDate(dataFilter)}`
        console.log('this.startDate', this.startDate)
        console.log('this.endDate', this.endDate)
        await analyticService.getDashBoardGrl(this.getUserData.id, {
          start_date: `${formatDate(currentData)}`,
          end_date: `${formatDate(dataFilter)}`,
        })
          .then(res => {
            this.responseGeral = res
            this.getAnalyticUserId()
          })
      }
      if (this.selectedValue.length > 0) {
        dataFilter.setDate(dataFilter.getDate() - (30 - dataFilter.getDay() + 2))
        this.endDate = `${formatDate(currentData)}`
        this.startDate = `${formatDate(dataFilter)}`
        analyticService.getByIdVslObjts(this.selectedValue, {
          start_date: `${formatDate(currentData)}`,
          end_date: `${formatDate(dataFilter)}`,
        })
          .then(res => {
            this.responseObj = res
            this.getAnaliseVsl()
          })
      }
    },
    async getFilterDataTempoTodo(dataFilter) {
      if (this.selectedValue.length === 0) {
        await analyticService.getDashBoardTempoTodo(this.getUserData.id)
          .then(res => {
            this.responseGeral = res
            this.getAnalyticUserId()
          })
      }
      if (this.selectedValue.length > 0) {
        await analyticService.getDashBoardTempoTodoVsl_Id(this.selectedValue)
          .then(res => {
            this.responseObj = res
            this.getAnaliseVsl()
          })
      }
    },

    async getFilterDataIntervalo() {
      if (this.selectedValue.length === 0) {
        await analyticService.getDashBoardGrl(this.getUserData.id, {
          start_date: `${this.startDate}`,
          end_date: `${this.endDate}`,
        })
          .then(res => {
            this.responseGeral = res
            this.getAnalyticUserId()
          })
      }
      if (this.selectedValue.length > 0) {
        await analyticService.getByIdVslObjts(this.selectedValue, {
          start_date: `${this.startDate}`,
          end_date: `${this.endDate}`,
        })
          .then(res => {
            this.responseObj = res
            this.getAnaliseVsl()
          })
      }
    },

    async getData() {
      const IdUsuario = this.getUserData.id
      const options = { method: 'GET', headers: { 'Content-Type': 'application/json' } }

      await fetch(`${this.VUE_APP_HOST_API_BACKEND}/usuario/${IdUsuario}`, options)
        .then(response => response.json())
        .then(response => {
          const ativo = (response[0].user_ativo)
          const obj = JSON.parse(localStorage.getItem('userData'))
          obj.user_ativo = ativo

          localStorage.setItem('userData', JSON.stringify(obj))
        })
        .catch(err => console.error(err))
    },
    async getAnaliseVsl() {
      const obj = await this.responseObj
      this.visualizacao = obj.map(i => i.qtde_load)
      this.engajamentoG = obj.map(i => i.engajamento)
      this.playy = obj.map(i => i.qtde_play)
      this.data = obj.map(i => i.agrupamento)
      const formattedDates = this.data
        .sort((a, b) => new Date(a).valueOf() - new Date(b).valueOf())
        .map(date => this.$moment(date).locale('pt-br').format('DD MMM'))

      const quantidadeObj = (obj.length)
      const valortotalEng = obj.reduce((acc, val) => acc + val.engajamento, 0)

      const EngajamentoTotal = valortotalEng === 0 && quantidadeObj === 0 ? 0 : valortotalEng / quantidadeObj
      const Engajamento = EngajamentoTotal === 0 ? '0' : EngajamentoTotal.toFixed(2)

      const SomaPlayRate = obj.reduce((acc, val) => acc + val.playRate, 0)

      const valorRate = SomaPlayRate === 0 && quantidadeObj === 0 ? 0 : SomaPlayRate / quantidadeObj
      const playRate = valorRate === 0 ? '0' : valorRate.toFixed(2)

      this.Views.views = obj.reduce((acc, val) => acc + val.qtde_load, 0)

      this.Play.play = obj.reduce((acc, val) => acc + val.qtde_play, 0)

      this.PlayRate.playRate = playRate

      this.Engajamento.engajamento = Engajamento

      this.objsFunnelGeral = [
        this.Views.views || 0,
        this.Play.play || 0,
        this.PlayRate.playRate || 0,
        this.Engajamento.engajamento || 0,
      ]

      // que ja stava fora do then
      const vw = this.visualizacao
      const newDataEngajamt = this.engajamentoG.map(num => num.toFixed(1))
      const newDataPlay = this.playy
      const newDataView = vw
      this.revenueComparisonLine.series = [
        {
          data: newDataView,
        },
        {
          data: newDataEngajamt,
        },
      ]
      this.PlayXengajamento.series = [
        {
          data: newDataPlay,
        },
        {
          data: newDataEngajamt,
        },
      ]

      this.PlayXengajamento.chartOptions.xaxis.categories = formattedDates
      this.revenueComparisonLine.chartOptions.xaxis.categories = formattedDates

      this.$refs.playEngaja.init(this.PlayXengajamento)
      this.$refs.playEngaja.refresh()
      this.$refs.viewsEngagementLine.init(this.revenueComparisonLine)
      this.$refs.viewsEngagementLine.refresh()
    },
    async getAnalyticUserId() {
      const objt = this.responseGeral
      this.data = objt.map(i => i.agrupamento)
      const formattedDates = this.data
        .sort((a, b) => new Date(a).valueOf() - new Date(b).valueOf())
        .map(date => this.$moment(date).locale('pt-br').format('DD MMM'))
      this.visualizacao = objt.map(i => i.qtde_load)
      this.engajamentoG = objt.map(i => i.engajamento)
      this.playy = objt.map(i => i.qtde_play)

      const quantidadeObj = (objt.length)
      const valortotalEng = objt.reduce((acc, val) => acc + val.engajamento, 0)
      const EngajamentoTotal = valortotalEng === 0 && quantidadeObj === 0 ? 0 : valortotalEng / quantidadeObj
      const Engajamento = EngajamentoTotal === 0 ? '0' : EngajamentoTotal.toFixed(2)

      const SomaPlayRate = objt.reduce((acc, val) => acc + val.playRate, 0)

      const valorRate = SomaPlayRate === 0 && quantidadeObj === 0 ? 0 : SomaPlayRate / quantidadeObj
      const playRate = valorRate === 0 ? '0' : valorRate.toFixed(2)

      this.Views.views = objt.reduce((acc, val) => acc + val.qtde_load, 0)

      this.Play.play = objt.reduce((acc, val) => acc + val.qtde_play, 0)

      this.PlayRate.playRate = playRate

      this.Engajamento.engajamento = Engajamento

      this.objsFunnelGeral = [
        this.Views.views || 0,
        this.Play.play || 0,
        this.PlayRate.playRate || 0,
        this.Engajamento.engajamento || 0,
      ]

      const vw = this.visualizacao
      const newDataEngajamt = this.engajamentoG.map(num => num.toFixed(2))
      const pl = this.playy
      const newDataView = vw
      const newDataEngaPl = pl

      this.revenueComparisonLine.series = [
        {
          data: newDataView,
        },
        {
          data: newDataEngajamt,
        },
      ]
      this.PlayXengajamento.series = [
        {
          data: newDataEngaPl,
        },
        {
          data: newDataEngajamt,
        },
      ]
      this.PlayXengajamento.chartOptions.xaxis.categories = formattedDates
      this.revenueComparisonLine.chartOptions.xaxis.categories = formattedDates

      this.$refs.playEngaja.init(this.PlayXengajamento)
      this.$refs.playEngaja.refresh()
      this.$refs.viewsEngagementLine.init(this.revenueComparisonLine)
      this.$refs.viewsEngagementLine.refresh()
    },
    async getvsls() {
      await api.get(`vslUserId/${this.getUserData.id}`)
        .then(response => {
          this.options = response.data
        })
    },
  },
}
</script>
<style>
#views {
  background-color: #18d9ad;
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.218);
}

#views:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);

}

#paly {
  background-color: #f5a732;
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.218);
}

#PlayRate {
  background-color: #318feb;
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.218);
}

#Engajamento {
  background-color: #ee566f;
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.218);
}

#textView {
  color: #266355;
}

#textPlay {
  color: #986f3a;
}

#textPlayRate {
  color: #2b5485;
}

#textEngajamento {
  color: #983545;
}

#text2 {
  color: #ffffff
}

.aling-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  justify-self: center;
  text-align: center;
  padding-left: 22px;
}

#card1 {
  background: #4db099;
  width: 70px;
  height: 70px;
  border-radius: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

#card2 {
  background: #cf974c;
  width: 70px;
  height: 70px;
  border-radius: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

#card3 {
  background: #3f7fc9;
  width: 70px;
  height: 70px;
  border-radius: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

#card4 {
  background: #cd5065;
  width: 70px;
  height: 70px;
  border-radius: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.aling-icon .aling-center-icon-item i {
  color: white;
  font-size: 30px;
}
.graphic{
  background-color: #393862;
}
</style>
